import { ModelPrepped, ModelWithoutId } from 'app/type';

import { RestfulApiService } from './restful-api.service';
import { Category } from '../model/cris/category';

class CategoryService extends RestfulApiService<Category> {
    public deploy(entity: Category) {
        return this.http.post<string[]>(`${this.getAlterUrl(entity)}/deploy`);
    }

    protected getFormName(): string {
        return 'category';
    }

    protected getPath(): string {
        return 'categories';
    }

    protected prepareSaveData(entity: ModelWithoutId<Category>): ModelPrepped<Category> {
        return {
            ...entity,
            dateCreated: undefined,
            dateEdited: undefined,
        };
    }
}

export const categoryService = new CategoryService();
